import { css } from '@emotion/react';
import LogoPms from '@/assets/images/logo-pms.png';
import ThankYouImg from '@/assets/images/thank-you.png';
import WaterImg from '@/assets/images/water.png';
import DotSvg from '@/assets/svgs/dot.svg?react';

export function NotificationToolTipStandard() {
  return (
    <div css={tooltipContainerStyles}>
      <div css={titleStyles}>Hình minh hoạ thông báo</div>

      <div css={notificationCardStyles}>
        <div css={dotWrapperStyles}>
          <DotSvg width={6} height={6} />
        </div>

        <div css={smallThumbStyles}>
          <img src={WaterImg} alt='water' />
        </div>

        <div css={textContentStyles}>
          <div css={timeStyles}>18:00, 25/03/2025</div>
          <div css={notificationTitleStyles}>🥛 Nhắc nhở uống nước!</div>
          <div css={notificationDescStyles}>Hôm nay bạn đã uống nước chưa</div>
        </div>
      </div>
    </div>
  );
}

export function NotificationToolTipFeature() {
  return (
    <div css={tooltipContainerStyles}>
      <div css={titleStyles}>Hình minh hoạ thông báo</div>

      <div css={featuredNotificationStyles}>
        <div css={dotWrapperLargeStyles}>
          <DotSvg width={6} height={6} />
        </div>

        <div css={avatarStyles}>
          <img src={LogoPms} alt='pms' />
        </div>

        <div css={featuredContentStyles}>
          <div css={featuredTimeStyles}>18:00, 23/03/2025</div>
          <div css={featuredTitleTextStyles}>
            🥰🥰🥰 Cảm ơn vì đã chọn PMS trong suốt thời gian qua
          </div>

          <div css={featuredImageContainerStyles}>
            <img src={ThankYouImg} css={featuredImageStyles} alt='thank you' />
          </div>

          <div css={featuredFooterStyles}>Hôm nay bạn đã uống nước chưa</div>
        </div>
      </div>
    </div>
  );
}

// Styles
const tooltipContainerStyles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
`;

const titleStyles = css`
  font-size: 1.2rem;
  color: #000000;
  align-self: flex-start;
  padding-left: 0.6rem;
`;

const notificationCardStyles = css`
  background: #e8faf8;
  padding: 0.6rem 0.8rem;
  padding-right: 2rem;
  display: flex;
  gap: 0.74rem;
  align-items: center;
`;

const timeStyles = css`
  font-size: 1rem;
  color: #858585;
`;

const dotWrapperStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.2rem;
`;

const dotWrapperLargeStyles = css`
  ${dotWrapperStyles};
  margin-top: 1.2rem;
`;

const smallThumbStyles = css`
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 0.3rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const textContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  text-align: left;
`;

const notificationTitleStyles = css`
  font-weight: 600;
  font-size: 1.2rem;
  color: #333;
  line-height: 1.4;
`;

const notificationDescStyles = css`
  font-size: 1.1rem;
  color: #333;
  line-height: 1.4;
`;

const featuredNotificationStyles = css`
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  background: #e8faf8;
  padding: 0.6rem 0.8rem;
`;

const featuredContentStyles = css`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

const avatarStyles = css`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const featuredTimeStyles = css`
  font-size: 1rem;
  color: #858585;
  margin-bottom: -0.4rem;
`;

const featuredTitleTextStyles = css`
  font-size: 1.2rem;
  color: #333;
  line-height: 1.4;
  font-weight: 500;
`;

const featuredImageContainerStyles = css`
  margin-bottom: 0.2rem;
`;

const featuredImageStyles = css`
  width: 22rem;
  max-width: 22rem;
  display: block;
`;

const featuredFooterStyles = css`
  font-size: 1.1rem;
  color: #333;
`;
